<template>
  <div class="unread">
    <el-tooltip effect="dark" content="项目通知" placement="bottom" :disabled="show">
      <!-- <i class="icon iconfont iconicon_selected_more_task"></i> -->
      <el-popover
        ref="my-popover"
        trigger="click"
        v-model="show"
        placement="bottom"
        width="534"
      >
        <div class="icon-post" slot="reference">
          <div>
            <i class="icon iconfont iconicon_project_messages activeIconHover"></i>
          </div>
          <div
            class="task-msgcount task-msgcount-post task-msgcount-top"
            v-if="messageListTotal"
          >
            {{ messageListTotal }}
          </div>
        </div>

        <div class="task-msg-list-wrap" v-loading="isLoading">
          <div class="task-msg-list-header">
            <div class="tit">项目通知</div>
            <div class="read-all-wrap" @click="readAll" v-show="messageList.length">
              <i class="icon iconfont iconicon_all_read"></i>
              <span>全部标记为已读</span>
            </div>
          </div>
          <ul class="task-msg-llist-content" v-infinite-scroll="loadMore">
            <li
              class="msg-item"
              :class="{[item.is_read ? 'is-real' : 'not-real']: true}"
              v-for="item in messageList"
              :key="item.id"
              @click="checkTask(item)"
            >
              <div class="msg-itme-_desc">
                <MyAvatar :userName="item.message_sender_user.realname" :imgUrl="item.message_sender_user.user_avatar" width="30px" height="30px">{{item.message_sender_user.realname}}</MyAvatar>
                <div class="msg-item_date">{{resetTime(item.create_time)}}</div>
                <div class="real-icon tableIconHover" @click.stop="readMessage(item)">
                  <i class="icon iconfont iconicon_selected_more_task "></i>设为已读
                </div>
              </div>
              <div class="real-notice message-model" @click="messageHasClick($event,item)" v-html="getTaskModel(item, true)"></div>

              <div class="real-tip">

                <!-- 项目 -->
                <span v-if="item.project && cross_project_id" class="text-blue" @click.stop="openMessageTypeLink(item)">
                  <i class="icon iconfont iconicon_action_item"></i>
                  {{item.project.title}}
                </span>

                <!-- 任务 -->
                <span v-if="item.task" class="text-blue" :class="{'not-click': item.raw_data.action === 'delete_task'}" @click.stop="openMessageTypeLink(item)">
                  <span v-if="cross_project_id" style="margin-right: 8px;margin-left: 6px;">/</span>
                  <i class="icon iconfont iconicon_task_message2"></i>
                  {{item.task.task_name}}
                </span>

                <!-- 里程碑 -->
                <span v-if="item.cross_projects_milestone" class="text-blue" @click.stop="openMessageTypeLink(item)">
                  <i class="icon iconfont iconicon_task_message2"></i>
                  {{item.cross_projects_milestone.milestone_name}}
                </span>

              </div>
            </li>
            <nothing class="null-box" v-if="!messageList.length && !isLoading" :config="{tip:'暂无消息通知',type:'img_no_news_notification'}"></nothing>
            <p class="loading-box" v-show="loading"><i class="el-icon-loading"></i>加载中...</p>
          </ul>
          <div class="check-all text-btn-active" @click="handleGo">
            查看所有通知
            <i class="icon iconfont iconicon_arrow_task_1"></i>
          </div>
        </div>
      </el-popover>
    </el-tooltip>
  </div>
</template>
<script>
import { mapActions, mapState, mapGetters, mapMutations } from 'vuex';
import MyAvatar from '@/components/avatar'
import api from '@/services/api/realMessage/realMessage'
import bus from '@/bus'
export default {
  components: {
    MyAvatar
  },
  props: {
    messageListTotal: {
      type: Number,
      default: 0
    },
    projectId: {
      type: [Number, String],
      default: ''
    },
    cross_project_id: {
      type: [Number, String],
      default: ''
    },
  },
  watch: {
    show() {
      if(this.show){
        // this.nextTemp() // 初始化先获取消息列表，为的是获取角标的数字
        this.isLoading = true
        this.init()
        this.loadMore()
      }
    }
  },
  data() {
    return {
      loading: false,
      noMore: false,
      show: false,
      msgVisible: false,
      page: 1,
      per_page: 10,
      messageList: [],
      isLoading: false
    }
  },
  created() {
    // this.nextTemp() // 初始化先获取消息列表，为的是获取角标的数字
  },
  methods: {
    ...mapActions('project/project', ['setProjectMessageIsRead']),
    init() {
      this.page = 0
      this.loading = false
      this.noMore = false
      this.messageList = []
    },
    loadMore() {
      if (this.loading || this.noMore) {
        return
      }
      this.page = this.page + 1;
      this.nextTemp()
    },
     nextTemp() {
      this.loading = true
      let params = {
        page: this.page,
        per_page: this.per_page,
        project_id: this.projectId,
        cross_project_id: this.cross_project_id,
        message_type: 0,
        is_read: 0
      }
      api.historyMessageLogs(params).then(res => {
        // this.total  = res.total
        this.messageList.push(...res.data)
        if (res.data.length == 0) {
          this.noMore = true
        }
        this.loading = false
        this.isLoading = false
      }).catch(err => {
        this.loading = false
        this.noMore = true
      })
    },
    async readMessage(temp) {
      await api.setMessageRead({message_id: temp.id, one_click_read: 0})
      this.$set(temp, 'is_read', 1)
      bus.$emit('sendMessageReal')
      bus.$emit('close');
      this.$emit('close')
    },
    async readAll() {
      await api.setMessageRead({one_click_read: 1, project_id: this.project_id, cross_project_id: this.cross_project_id})
      this.init()
      this.loadMore()
      bus.$emit('sendMessageReal')
      bus.$emit('close');
      this.$emit('close')
    },
    handleGo() {
      // this.show = false
      let params = this.projectId ? `project_id=${this.projectId}` : `cross_project_id=${this.cross_project_id}`
      this.$router.push(`/realMessageTask?${params}&isTab=true`)
    },
    checkTask(item) {
      this.readMessage(item)
      this.$nextTick(() => {
        this.openMessageTypeLink(item)
      })
    }
  }
}
</script>
<style lang="scss">
.unread {
  .el-tooltip {
    display: inline-block;
  }
  .el-popover__reference-wrapper {
    width: 100%;
    display: inline-block;
  }
  .icon-post {
    position: relative;
  }
}
.task-msg-list-wrap {
  .msg-item {
    cursor: pointer;
  }
}

</style>
